import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import createInfo from "../Announcements/Announcement.module.css";
import { AxiosInstance } from "../../../../axios";
import toast from "react-hot-toast";
import Loader from "../../Loader";
import moment from "moment";

export default function CourierCharges() {
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id not available in session storage");
  }

  const navigate = useNavigate();
  const [initialfields, setInitialfields] = useState({
    start_range: "",
    end_range: "",
    amount: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});

  // refs
  const amount = useRef(null);
  const startRange = useRef(null);
  const endRange = useRef(null);

  // Validation function
  const validateFields = (data) => {
    const errors = {};

    const validateRange = (value, fieldName) => {
      const valueStr = value ? value.toString() : "";
      const numVal = parseInt(value, 10);

      if (!valueStr) {
        errors[fieldName] = `Please enter ${fieldName.replace("_", " ")}`;
      } else if (isNaN(numVal)) {
        errors[fieldName] = `${fieldName.replace("_", " ")} must be a number`;
      } else if (!/^\d+$/.test(valueStr)) {
        errors[fieldName] = `${fieldName.replace(
          "_",
          " "
        )} must be a whole number`;
      } else if (numVal <= 0) {
        errors[fieldName] = `${fieldName.replace(
          "_",
          " "
        )} must be greater than 0`;
      } else if (valueStr.length > 5) {
        errors[fieldName] = `${fieldName.replace(
          "_",
          " "
        )} cannot be more than 5 digits`;
      }
    };

    validateRange(data.start_range, "start_range");
    validateRange(data.end_range, "end_range");
    validateRange(data.amount, "amount");

    setError(errors);
    validateFocusCommentSection(errors);
    return errors;
  };

  // focus on first invalid field
  const validateFocusCommentSection = (errors) => {
    if (errors.start_range) {
      startRange.current.focus();
    } else if (errors.end_range) {
      endRange.current.focus();
    } else if (errors.amount) {
      amount.current.focus();
    }
  };

  const handleSubmit = () => {
    const errors = validateFields(initialfields);
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    try {
      const courierData = {
        id: "",
        start_gram_range: initialfields.start_range,
        end_gram_range: initialfields.end_range,
        amount: initialfields.amount,
        created_by: userid,
      };

      AxiosInstance.post(`/api/book/courier/add`, courierData)
        .then((res) => {
          const { status, message, amtErr, addErr } = res.data;

          if (status === true) {
            toast.success(message);
            navigate(-1);
          } else {
            // Map backend error flags to specific field errors
            let newErrors = {};

            if (addErr === false) {
              newErrors.start_range = message;
              newErrors.end_range = message;
            }

            if (amtErr === false) {
              newErrors.amount = message;
            }

            setError((prev) => ({
              ...prev,
              ...newErrors,
            }));
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
        });
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));

    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const navigateToPreviousScreen = () => {
    navigate(-1);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">Create Courier Charge</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                onClick={navigateToPreviousScreen}
                className="secondaryButton"
                variant="secondary"
              >
                Back to Courier Charges
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center"
                variant="primary"
              >
                Save Courier Charge
              </Link>
            </li>
          </ul>
        </div>

        <div className="row m-0 mb-5">
          <fieldset className="mt-3">
            <legend className="w-auto">Courier Charge Details</legend>
            <form className="row g-3">
              <div className="col-md-6">
                <label className="form-label confirm_value">
                  Start Weight Range (in grams)
                </label>
                <input
                  ref={startRange}
                  type="number"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  value={initialfields.start_range}
                  name="start_range"
                  placeholder="Enter the start range"
                  onChange={handleChange}
                />
                {error.start_range && (
                  <small className={createInfo.errors}>
                    {error.start_range}
                  </small>
                )}
              </div>

              <div className="col-md-6">
                <label className="form-label confirm_value">
                  End Weight Range (in grams)
                </label>
                <input
                  ref={endRange}
                  type="number"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  value={initialfields.end_range}
                  name="end_range"
                  placeholder="Enter the end range"
                  onChange={handleChange}
                />
                {error.end_range && (
                  <small className={createInfo.errors}>{error.end_range}</small>
                )}
              </div>

              <div className="col-md-6">
                <label htmlFor="amount" className="form-label confirm_value">
                  Amount
                </label>
                <input
                  ref={amount}
                  type="number"
                  className="desc_input_text w-100 rounded-2 input-font-size-sm"
                  placeholder="Enter the amount"
                  value={initialfields.amount}
                  name="amount"
                  onChange={handleChange}
                />
                {error.amount && (
                  <small className={createInfo.errors}>{error.amount}</small>
                )}
              </div>
            </form>
          </fieldset>
        </div>

        <div className="col-md-12 col-12 ListBtn mb-5">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                onClick={navigateToPreviousScreen}
                className="secondaryButton"
                variant="secondary"
              >
                Back to Courier Charges
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center"
                variant="primary"
              >
                Save Courier Charge
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
